import { render, staticRenderFns } from "./OtherDeliveryListItem.vue?vue&type=template&id=5f50bf6d&scoped=true"
import script from "./OtherDeliveryListItem.vue?vue&type=script&lang=js"
export * from "./OtherDeliveryListItem.vue?vue&type=script&lang=js"
import style0 from "./OtherDeliveryListItem.vue?vue&type=style&index=0&id=5f50bf6d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f50bf6d",
  null
  
)

export default component.exports